export enum TextMergeBuilderPage {
    TextEditor = "Text Editor",
    Data = "Data",
    Test = "Test",
    Configuration = "Config",
}
